module.exports = __webpack_public_path__ + "static/media/scrabblemini.d852888d.png";